export type StorePriceTier = 'u25' | '25_50' | '50_100' | '100_250' | '250p'
export type StoreSort = 'price_asc' | 'price_desc' | 'newest' | 'popular'

export type StoreFilters = {
  q?: string
  category?: string | null
  condition?: 'new' | 'used' | null
  inStockOnly?: boolean
  sort?: StoreSort
  priceTier?: StorePriceTier | null
  priceMin?: number | null
  priceMax?: number | null
}

export const DEFAULT_STORE_FILTERS: StoreFilters = {
  q: '',
  category: null,
  condition: null,
  inStockOnly: false,
  sort: 'newest',
  priceTier: null,
  priceMin: null,
  priceMax: null,
}

export function normalizeStoreFilters(input?: Partial<StoreFilters> | null): StoreFilters {
  const f = input ?? {}
  return {
    q: f.q ?? '',
    category: f.category ?? null,
    condition: f.condition ?? null,
    inStockOnly: Boolean(f.inStockOnly),
    sort: (f.sort as StoreSort) ?? 'newest',
    priceTier: f.priceTier ?? null,
    priceMin: typeof f.priceMin === 'number' ? f.priceMin : null,
    priceMax: typeof f.priceMax === 'number' ? f.priceMax : null,
  }
}

export function serializeStoreFilterParams(input?: StoreFilters | null): Record<string, any> {
  const f = normalizeStoreFilters(input ?? undefined)
  const params: Record<string, any> = {}
  // Match mobile mapping (mobile/src/api/pixe_store.ts → mapFiltersToBackend)
  if (f.q && f.q.trim()) params.q = f.q.trim()
  if (f.category) params.category = f.category
  if (f.condition) params.condition = f.condition
  if (f.inStockOnly) params.in_stock = 'true'
  if (f.sort) params.sort = f.sort
  if (f.priceMin != null) params.price_min = f.priceMin
  if (f.priceMax != null) params.price_max = f.priceMax
  return params
}
